import React, { useEffect, useState } from 'react'
import useMobileDetect from 'helpers/mobile-detect'
import dynamic from 'next/dynamic'
import Layout from '../components/layout/layout'
import TestimonialsHelper from '../helpers/testimonials'
import TBanner from 'components/testimonial/tbanner/index.js'

import styles from 'components/testimonial/testimonial.module.scss'

const MyStory = dynamic(() => import('../components/testimonial/my-story/index.js'))
const LogoBar = dynamic(() => import('../components/share/logo-bar/index'))
const DolceTransformation = dynamic(() => import('../components/testimonial/dolce-transformation/index'))
const MakingExcuse = dynamic(() => import('../components/share/making-excuse/index'))
const TrainerEvent = dynamic(() => import('../components/testimonial/trainer-event/index'))
const ChooseProgram = dynamic(() => import('../components/share/choose-program/index'))
const UserQuote = dynamic(() => import('../components/testimonial/user-quote/index'))

function Testimonials (props) {
  const [bgUserQuote, setBgUserQuote] = useState(
    '/static/images/testimonials/user-quote2.png'
  )
  const currentDevice = useMobileDetect()
  const [listImages] = useState([
    {
      id: 1,
      imageUrl: '/static/images/logo/Womenshealthlogo_pink.svg',
      title: "Women's Health",
      width: '115',
      height: '24'
    },
    {
      id: 2,
      imageUrl: '/static/images/logo/Muscle__and__Fitness.svg',
      title: 'Muscle and Fitness',
      width: '62',
      height: '27'
    },
    {
      id: 3,
      imageUrl: '/static/images/logo/mens-fitness.svg',
      title: "Men's Fitness",
      width: '103',
      height: '20'
    },
    {
      id: 4,
      imageUrl: '/static/images/logo/Group2.svg',
      title: 'Fox',
      width: '86',
      height: '24'
    },
    {
      id: 5,
      imageUrl: '/static/images/logo/Cosmopolitan_logo_pink.svg',
      title: 'Cosmopolitan',
      width: '113',
      height: '22'
    },
    {
      id: 6,
      imageUrl: '/static/images/logo/TSN_Logo_red.svg',
      title: 'TSN'
    },
    {
      id: 7,
      imageUrl: '/static/images/logo/ask-men-logo.svg',
      title: 'askmen',
      width: '98',
      height: '26'
    },
    {
      id: 8,
      imageUrl: '/static/images/logo/Asset1.svg',
      title: "Men's Health",
      width: '107',
      height: '24'
    },
    {
      id: 9,
      imageUrl: '/static/images/logo/Group78.svg',
      title: 'Sports Illustrated',
      width: '92',
      height: '25'
    }
  ])

  useEffect(() => {
    if (currentDevice.isMobile()) {
      setBgUserQuote('/static/images/testimonials/m-user-quote.png')
    } else {
      setBgUserQuote('/static/images/testimonials/user-quote2.png')
    }
  }, [currentDevice.isMobile()])

  return (
    <Layout isSubscribe={false}>
      <div className={styles['testimonial-container__wrapper']}>
        <TBanner />
        <MyStory />
        <LogoBar images={listImages} />
        <DolceTransformation data={props.testimonials} />
        <MakingExcuse
          image='/static/images/testimonials/making-excuse.png'
          imageMobile='/static/images/testimonials/making-excuse-mb.png'
          textButton='START YOUR JOURNEY TODAY!'
          textMobile="LET'S DO THIS!"
          className={styles['testimonial-container__testimonial']}
        />
        <TrainerEvent />
        <ChooseProgram />
        <UserQuote bgUserQuote={bgUserQuote} />
      </div>
    </Layout>
  )
}

export async function getServerSideProps () {
  const featured = await TestimonialsHelper.getAllFeatured()
  const recent = await TestimonialsHelper.getAllRecent()

  return {
    props: {
      testimonials: {
        featured,
        recent
      }
    }
  }
}

export default Testimonials
